import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Container, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import IncidentTile from '@ui/components/IncidentTile';
import SectionHeader from '@ui/components/SectionHeader';
import CarImage from '@public/assets/images/no-preview.png';
import useAlertsListStyles from './useAlertsStyles';
import useHeaderStyles from '@ui/layout/Layout/components/Header/useHeaderStyles';
import { useTranslation } from 'react-i18next';
import { colCenter } from '@ui/style/style';
import incidentsApi from '@application/api/endpoints/incident-api';
import { formatDMY } from '@application/utilities/date-time-formater';
import { useAlertContext } from './AlertContext';
const Alerts = ({}) => {
    const [activeFilter, setActiveFilter] = useState('All');
    const navigate = useNavigate();
    const { t } = useTranslation();
    const theme = useTheme();
    const isLightMode = theme.palette.mode === 'light';
    const { ContainerStyles, ContentContainerStyles } = useAlertsListStyles();
    const { alerts, setAlerts } = useAlertContext();
    const { MobileHeaderContainer, NavTitleContainer, NavInner, markAsReadButtonStyles } = useHeaderStyles();
    const [sortValue, setSortValue] = useState('asc');
    const [filterValues, setFilterValues] = useState({
        range: [1.5, 10],
        startDate: dayjs(),
        endDate: dayjs()
    });
    const [FilteredAlert, setFilteredAlert] = useState([]);
    const handleAlertTileClick = async (id) => {
        if (id) {
            navigate(`/incident-history/${id}/details`);
            await incidentsApi.updateIncidentAlerts(id);
        }
    };
    useEffect(() => {
        const getIncidentAlerts = async () => {
            try {
                const response = await incidentsApi.getIncidentAlerts();
                if (response.isSuccess && response?.data) {
                    setAlerts && setAlerts(response?.data);
                }
            }
            catch (error) { }
        };
        getIncidentAlerts();
    }, [open]);
    useEffect(() => {
        activeFilter === 'All'
            ? setFilteredAlert(alerts?.allIncidentAlert)
            : setFilteredAlert(alerts?.criticalIncidentAlert);
    }, [activeFilter, alerts]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { sx: MobileHeaderContainer, className: 'mobile-nav-container', children: _jsxs(Box, { className: 'nav-inner', sx: NavInner, children: [_jsx(Box, { sx: NavTitleContainer, className: 'nav-title', children: _jsx(Typography, { variant: 'h4', className: 'mobile-nav-title', color: isLightMode ? theme.palette.common.white : theme.palette.grey[900], children: "Alerts" }) }), _jsx(Button, { size: 'small', variant: 'text', sx: markAsReadButtonStyles, children: t('MarkAsRead') })] }) }), _jsxs(Container, { id: 'page-alerts', sx: ContainerStyles, children: [_jsx(SectionHeader, { isAlertFilter: true, title: 'Alerts List', showRangeSlider: false, setSortValue: setSortValue, setFilterValues: setFilterValues, sortOptions: [], buttonSortOptions: [], sortValue: sortValue, haveFilter: false, haveSorting: false, filterValues: filterValues }), _jsxs(Box, { sx: { ...colCenter, px: 2.1, py: 1, gap: 1 }, children: [_jsx(Button, { variant: activeFilter === 'All' ? 'contained' : 'soft', color: 'inherit', size: 'small', sx: { borderRadius: '100px' }, onClick: () => setActiveFilter('All'), children: "All" }), _jsx(Button, { size: 'small', sx: { borderRadius: '100px' }, variant: activeFilter === 'Critical' ? 'contained' : 'soft', color: 'inherit', onClick: () => setActiveFilter('Critical'), children: "Critical" })] }), _jsx(Box, { sx: ContentContainerStyles, className: 'alerts-content-container', children: FilteredAlert?.map((alert) => (_jsx(IncidentTile, { showImagePreviewIcon: false, incidentId: alert.incidentId, onAlertClick: handleAlertTileClick, variant: 'alert', date: formatDMY(alert.incidentDate), isRead: alert.isRead, score: alert.totalScore, time: alert.incidentTime, imgSrc: alert.imageUrl
                                ? `${process.env.BLOB_BASE_URL}${process.env.FOLDER_NAME}/Images/${alert.imageUrl}`
                                : CarImage, title: alert.licensePlate, venue: alert.location, legend: alert.legend }))) })] })] }));
};
export default Alerts;
